import { useEffect, useMemo, useState } from "react";
import { endOfMonth, format, startOfMonth } from "date-fns";
import booking from "@/shared/api/booking";
import { CalendarWithTime } from "../common/CalendarWithTime";
import { BookingForm } from "../common/BookingForm";
import { toast } from "sonner";

export const SchedulerPage = () => {
    const [bookingByDay, setBookingByDay] = useState(new Map());
    const [selectedDay, setSelectedDay] = useState(() => {
        const now = new Date()
        now.setHours(0, 0, 0, 0)
        return now
    })
    const [month, setMonth] = useState(new Date());
    const [time, setTime] = useState(null)

    const [name, setName] = useState("")
    const [phone, setPhone] = useState("")
    const [comment, setComment] = useState("")
    const [mode, setMode] = useState("admin")
    const [selectedBookingId, setSelectedBookingId] = useState(null)

    const formatLocalDate = (date) => {
        const year = date.getFullYear()
        const month = String(date.getMonth() + 1).padStart(2, "0")
        const day = String(date.getDate()).padStart(2, "0")
        return `${year}-${month}-${day}`
    }
    const dateKey = useMemo(() => (selectedDay ? formatLocalDate(selectedDay) : null), [selectedDay])

    function groupByDateMap(data) {
        const map = new Map()

        for (const item of data) {
            const date = item.date
            if (!map.has(date)) {
                map.set(date, [])
            }
            map.get(date).push(item)
        }

        return map
    }

    const handleSelectPeriod = async (from, to) => {
        try {
            const res = await booking.getBookingByPeriod(from, to);
            console.log(res)
            setBookingByDay(groupByDateMap(res));
        } catch (err) {
            console.error(err.message);
        }
    }

    useEffect(() => {
        const start = startOfMonth(month);
        const end = endOfMonth(month);

        const startStr = format(start, "yyyy-MM-dd");
        const endStr = format(end, "yyyy-MM-dd");

        if (month.getMonth() !== selectedDay.getMonth()) setSelectedDay(start);
        handleSelectPeriod(startStr, endStr).catch(console.error);
    }, [month]);

    const handleMarkedTimeSelected = (data) => {
        if (data !== null) {
            setMode("edit")
            setPhone(data.phone)
            setName(data.name)
            setComment(data.comment)
            setSelectedBookingId(data._id)
        } else {
            setMode("admin")
            setPhone("")
            setName("")
            setComment("")
            setSelectedBookingId(null)
        }
    }

    const onSubmit = async (e) => {
        e.preventDefault()

        // rawPhone уже содержит чистые цифры из состояния
        const rawPhone = phone;

        if (!time) {
            toast.error("Выберите время встречи")
            return
        }

        if (!selectedDay || !name || !rawPhone) {
            toast.error("Заполните все обязательные поля")
            return
        }

        // Валидация номера телефона (например, 375 и 9 цифр после)
        const phoneRegex = /^375\d{9}$/;
        if (!phoneRegex.test(rawPhone)) {
            toast.error("Пожалуйста, введите корректный номер телефона (например, +375 (XX) XXX-XX-XX)");
            return;
        }

        try {
            const payload = { date: format(selectedDay, "yyyy-MM-dd"), time, name, phone: '+' + rawPhone, comment }
            const res = await fetch(process.env.REACT_APP_BACKEND_URL + "/api/booking", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload)
            })

            const data = await res.json()
            if (!res.ok) throw new Error(data.message || "Ошибка бронирования")

            toast.success("Запись успешно создана. Мы свяжемся с вами по телефону.")
            setBookingByDay(prev => {
                if (prev?.get(format(selectedDay, "yyyy-MM-dd"))?.length) prev.get(format(selectedDay, "yyyy-MM-dd")).push({ _id: data.booking._id, time, name, phone: rawPhone, comment })
                else prev.set(format(selectedDay, "yyyy-MM-dd"), [{ _id: data.booking._id, time, name, phone: rawPhone, comment }])
                return prev
            });
            setSelectedBookingId(data.booking._id)

            setTime(null)
            setName("")
            setPhone("")
            setComment("")
        } catch (err) {
            toast.error(err.message)
        }
    }

    useEffect(() => {
        console.log(bookingByDay)
    }, [bookingByDay])

    return (
        <div className="bg-card rounded-lg border p-6">
            <div className="flex flex-row flex-wrap gap-4">
                {/* <ScheduleCalendar
                    handleDaySelected={setSelectedDay}
                    bookingByDay={bookingByDay}
                    selectedDay={selectedDay}
                    month={month}
                    handleMonthChanged={setMonth}
                /> */}
                <CalendarWithTime
                    dateKey={dateKey}
                    dateValue={selectedDay}
                    onDateChange={(date) => {
                        if (date) setSelectedDay(date)
                    }}
                    markedDatesMap={bookingByDay}
                    timeValue={time}
                    onTimeChange={setTime}
                    markedTimesMap={bookingByDay.get(format(selectedDay, "yyyy-MM-dd"))}
                    onMarkedTimeSelected={handleMarkedTimeSelected}
                />

                <BookingForm
                    mode={mode}
                    time={time}
                    date={selectedDay}
                    name={name}
                    phone={phone}
                    comment={comment}
                    setName={setName}
                    setPhone={setPhone}
                    setComment={setComment}
                    onSubmit={onSubmit}
                    handleBookingChanged={setBookingByDay}
                    id={selectedBookingId}
                    disabledTime={bookingByDay.get(format(selectedDay, "yyyy-MM-dd"))?.map(el => el.time)}
                />
            </div>
        </div >
    )
}